<template lang="pug">
  v-form(
    ref="form"
    v-model="valid"
    lazy-validation
  )
    v-text-field(
      label="Label"
      v-model="formData.label"
      data-test="custom-template-label"
      :readonly="formData.readonly"
      :disabled="formData.readonly"
      :error="formErrors.hasError('label')"
      :rules="labelRules"
      :error-messages="formErrors.fields.label"
    )
    v-text-field(
      label="Subject"
      v-model="formData.subject"
      :disabled="formData.readonly"
      :readonly="formData.readonly"
      :error="formErrors.hasError('subject')"
      :error-messages="formErrors.fields.subject"
      :rules="subjectRules"
    )
    v-textarea(
      outlined
      label="Content"
      :rows="12"
      placeholder="Type your text here..."
      :readonly="formData.readonly"
      v-model="formData.content"
      :disabled="formData.readonly"
      :error="formErrors.hasError('content')"
      :error-messages="formErrors.fields.content"
    )
    template(v-if="isLiveStreamTemplate")
      v-textarea(
        outlined
        label="Weekdays"
        :rows="6"
        :counter="100"
        :rules="liveStreamContentRules"
        placeholder="Type your text here..."
        required
        v-model="formData.weekdays"
        :error="formErrors.hasError('weekdays')"
        :error-messages="formErrors.fields.weekdays"
      )
      time-picker(
        label="Times"
        v-model="formData.time"
        data-test="custom-template-label"
        required
        :error="formErrors.hasError('time')"
        :error-messages="formErrors.fields.time"
      )
</template>

<script>
import TimePicker from '@/app/admin/components/TimePicker.vue';

const defaultFormData = () => ({
  label: null,
  subject: null,
  content: null,
  weekdays: null,
  time: {
    hour: '00',
    minute: '',
  },
  readonly: false
});

export default {
  components: {
    TimePicker,
  },
  props: {
    item: {
      type: Object
    },
    formErrors: Object
  },

  watch: {
    item(val) {
      if (!val) {
        this.formData = defaultFormData();
      }
      this.$refs.form.resetValidation();
    },
  },

  computed: {
    isLiveStreamTemplate() {
      return this.item.label === 'LIVE_STREAM_PROMO';
    },
  },

  data:() => ({
    formData: defaultFormData(),
    valid: true,
    liveStreamContentRules: [
      v => !!v || 'This field is required',
      v => v?.length <= 100 || 'Max. 100 characters',
    ],
    labelRules: [
      v => v?.length <= 15 || 'Label should contain 15 characters or less',
    ],
    subjectRules: [
      v => (!v || v?.length <= 255) || 'Subject should contain 255 characters or less',
    ],
  }),

  mounted() {
    this.setData()
  },

  methods: {
    setData() {
      if(!this.item) return
      this.formData.label = this.item.label
      this.formData.subject = this.item.subject
      this.formData.content = this.item.content
      if (this.item.fields?.length) {
        const timeValue = this.item.fields.find((item) => item.field_name === 'time_text').default
        this.formData.time = {
          hour: timeValue.split(':')[0],
          minute: timeValue.split(':')[1],
        };
        this.formData.weekdays = this.item.fields.find((item) => item.field_name === 'schedule_text').default
      }
      this.formData.readonly = this.item.readonly
    },

    validate() {
      return this.$refs.form.validate();
    },

    reset() {
      this.formData = defaultFormData();
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    getData() {
      const valid = this.$refs.form.validate();
      if (valid) {
        return {
          ...this.formData,
          ...(this.isLiveStreamTemplate ? {
            additional_fields: {
              schedule_text: this.formData.weekdays,
              time_text: `${this.formData.time.hour}:${this.formData.time.minute}`,
            },
          }: {}),
        }
      }
    }
  },
}
</script>